<template>
  <div class="new-reference__manual">
    <router-link :to="{name: 'Root'}" class="btn" style="padding:10px 5px 10px 0;">
      <i class="material-icons">arrow_back</i>
      <span>Start again</span>
    </router-link>

    <ReferenceForm :source="source" :referenceMetadata="referenceMetadata"></ReferenceForm>

    <div class="actions">
      <button @click="generateReference()" :disabled="isLoading" class="btn btn-raised bg-blue white">
        <span>
          <i class="material-icons">check</i>
          <span>{{isLoading ? 'Generating...' : 'Generate'}}</span>
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import Config from '@/config.js';
import ReferenceMetadata from '@/classes/ReferenceMetadata.js';
import AutociteApi from '@/services/autociteApi.js';
import MessageBus from '@/services/messageBus.js';

import ReferenceForm from '@/components/ReferenceForm';

export default {
  name: 'NewReferenceManual',
  components: {
    ReferenceForm
  },
  data () {
    return {
      referenceMetadata: {},
      isLoading: false,
      referenceFormTooltipTarget: null
    };
  },
  computed: {
    source () {
      return Config.sources.find((s) => {
        return s.id === this.$route.params.sourceId;
      });
    }
  },
  methods: {
    async generateReference () {
      this.isLoading = true;
      MessageBus.formattedReference = await AutociteApi.autociteMetadata(this.referenceMetadata, this.source.id, this.$route.params.styleId);
      this.$router.push({ name: 'FormattedReference', params: { styleId: this.$route.params.styleId } });
    }
  },
  beforeMount () {
    this.referenceMetadata = new ReferenceMetadata();
    this.referenceMetadata.addNamePlaceholders();
  },
  mounted () {
    // if the top of the widget is above the viewable window then scroll back to it
    if (document.getElementById('mb-widget').getBoundingClientRect().top < 0) {
      document.getElementById('mb-widget').scrollIntoView({behavior: 'smooth'});
    }
  }
}
</script>

<style lang="scss">
  .mb-widget {
    .new-reference__manual {
      .actions { align-items:center; border-top:1px dotted #e9eaed; display:flex; justify-content:center; padding:20px; }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/NewReferenceManual.vue